import { Utils } from "../../../common/views/Utils";
import { ContactInfo } from "../../../home/models/ContactInfo";
import { OrderModel, ShortOrderItemModel } from "../../../orders/models/OrderModel";
import { OrderUtils } from "../../../orders/views/shared/OrderUtils";
import { BankAccountModel, InvoiceDetailModel } from "../../models/InvoiceModel";
import InvoicePrintContactView from "./InvoicePrintContactView";
import InvoicePrintItemView from "./InvoicePrintItemView";
import InvoicePrintPaymentView from "./InvoicePrintPaymentView";

type InvoicePrintProps = {
    invoice: InvoiceDetailModel;
    bankAccounts: BankAccountModel[];
    contacts: ContactInfo[];
}

export default function InvoicePrintView({ invoice, bankAccounts, contacts }: InvoicePrintProps) {
    const countryCode = invoice.phone?.countryCode ?? "";
    const phoneNo = invoice.phone?.phoneNo ?? "";

    const width6 = Utils.getColumnWidth(6);

    const header = () => {
        return <div className="p-10 blue-background">
            <div className="ms-Grid-row">
                <div className={width6}>{invoice.id}</div>
                <div className={width6 + " right"}>{Utils.formatShortDate(invoice.date)}</div>
            </div>

            <div className="pt-5">{Utils.formatPhone2(countryCode, phoneNo)}</div>

            {!Utils.isNullOrEmpty(invoice.addressLine) &&
                <div className="pt-5">{invoice.addressLine}</div>}
        </div>;
    }

    const getTotalQty = () => {
        let total = 0;

        for (let i = 0; i < invoice.items.length; i++) {
            total += invoice.items[i].qty;
        }

        return total;
    }

    const summaryRow = (text: string, value: number) => {
        return <div className="ms-Grid-row pv-5">
            <div className={width6 + " left"}>{text}</div>
            <div className={width6 + " right"}>$ {value.toFixed(2)}</div>
        </div>
    }

    const summary = () => {
        return <div className="p-10 blue-background">
            <div className="ms-Grid-row pv-5">
                <div className={width6 + " left"}>Total Qty:</div>
                <div className={width6 + " right"}>{getTotalQty()}</div>
            </div>

            {summaryRow("Sub Total:", invoice.amount)}
            {summaryRow("Shipping Fee:", invoice.shipping)}
            {summaryRow("Deposit:", invoice.paid)}
            <div className="firmed font-bolder">
                {summaryRow("Remaining:", invoice.balance)}
            </div>
        </div>
    }

    return <div className="ms-Grid ml--10 mr--10 pb-10">
        {header()}

        <div className="ph-10">
            {invoice.items.map((item: ShortOrderItemModel) => {
                return <InvoicePrintItemView item={item} />
            })}
        </div>

        {summary()}

        <div className="pt-10">
            <InvoicePrintPaymentView accounts={bankAccounts} />
        </div>

        <div className="pt-10">
            <InvoicePrintContactView contacts={contacts} />
        </div>
    </div>;
}